import { is } from "date-fns/locale";

export const photoVerificationSteps = ['Photo Verification', 'Questionnaire', 'OTP verification'];

export const isNpsSteps = ['OTP verification'];

export const hybridPosvSteps = ['Photo Verification', 'Questionnaire', 'Consent Recording', 'OTP verification'];

export const QCSteps = ['Questionnaire', 'OTP verification'];


const photoVerificationStepsNewUI = ['Questionnaire', 'Photo Verification', 'OTP verification'];
const otpOnlyPosvStepsNewUI = ['Photo Verification', 'Questionnaire', 'OTP verification'];

const isNpsStepsNewUI = ['OTP verification'];
const clubbedOtpStepsNewUI = ['Policy Questions', 'Clubbed OTP', 'OTP verification'];

const hybridPosvStepsNewUI = ['Questionnaire', 'Photo Verification', 'Consent Recording', 'OTP verification'];

const QCStepsNewUI = ['Questionnaire', 'OTP verification'];

const TelebindingSteps = ['Personal Details', 'Proposal Review', 'Photo Verification ', 'Video Consent', 'Payment'];
const PhoneBankingSteps = ['Personal Details', 'Proposal Review', 'Photo Verification ', 'Video Consent'];





export const getNewUISteps = ( isTelebinding = false ) => {

    const isNps = localStorage.getItem('isNps')
    const journeyBy = localStorage.getItem('journeyBy')
    const isVideoPosv = localStorage.getItem('isVideoPosv')
    const twoStep = localStorage.getItem('twoStep')
    const lPosv = localStorage.getItem('lPosv')
    const otpOnlyPosv = localStorage.getItem('otpOnlyPosv')
    const isPhoneBanking = sessionStorage.getItem('isPhoneBanking')

    if (isPhoneBanking === "Y") {
      return PhoneBankingSteps;
    } else if (isTelebinding === "Y") {
      return TelebindingSteps;
    } else if (isNps == 'Y') {
      return isNpsStepsNewUI
    } else if (journeyBy == "P" && lPosv === 'false') {
      return clubbedOtpStepsNewUI
    } else if (isVideoPosv == 'Y') {
      return hybridPosvStepsNewUI
    } else if (twoStep == 'Y') {
      return QCStepsNewUI
    } else if (otpOnlyPosv == 'Y') {
      return otpOnlyPosvStepsNewUI
    }
    else {
      return photoVerificationStepsNewUI
    }
  }